export default __webpack_public_path__ + "static/media/help-guide.3b8dd18c.png";